import React, { useState } from 'react'
import "./StickyMenu3.css"
import {globals} from '../Globals/Globals'
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import { logout } from '../../redux/authSlice';
import {openModalAbout} from "../../redux/modalSlice"

const StickyMenu3 = props => {
    let navbar_top_ref = React.createRef();
    let navbar_intitial_offset_top = -1;
    let [Toggle,setToggle] = useState(false);
    let [Toggle2,setToggle2] = useState(false);
    let [Collapsed,setCollapsed] = useState(true);
    //let [navBackColor,setNavBackColor] = useState(props.navBackColor?props.navBackColor:"transparent");
    let [navBackColor,setNavBackColor] = useState(props.navBackColor?props.navBackColor:"black");//Force back color to black
    let [scrollTriggerCeil,setScrollTriggerCeil] = useState(props.scrollTriggerCeil?props.scrollTriggerCeil:40);
    let {isAuthenticated} = useSelector((state)=>state.auth);

    let dispatch = useDispatch();

    React.useEffect(
        () => {
            window.addEventListener('scroll', function() {
                if (navbar_top_ref.current){
                    if (navbar_intitial_offset_top == -1)
                        navbar_intitial_offset_top = navbar_top_ref.current.offsetTop;
                    
                    if (globals.parameters.sticky3_debug){
                        console.clear()
                        console.log("window.scrollY => ", window.scrollY)
                        console.log("navbar_intitial_offset_top => ", navbar_intitial_offset_top)
                        console.log("navbar_top_ref.current.offsetTop => ", navbar_top_ref.current.offsetTop)
                    }

                    //Stick process
                    if (window.scrollY > navbar_intitial_offset_top) {
                        navbar_top_ref.current.classList.add('fixed-menu-top');

                        if (!props.auto_padding){
                            // add padding top to show content behind navbar
                            let navbar_height = navbar_top_ref.current.offsetHeight;
                            document.body.style.paddingTop = navbar_height + 'px';
                        }
                    } else {
                        navbar_top_ref.current.classList.remove('fixed-menu-top');

                        // remove padding top from body
                        if (!props.auto_padding) document.body.style.paddingTop = '0';
                    }

                    //Back Color process
                    if (window.scrollY > scrollTriggerCeil) {
                        //Change back color as scroll position is greater than nav bar heigth

                        //Set scrollabled background color
                        if (globals.parameters.sticky3_debug)
                            console.log("set Opaque")
                            
                        setNavBackColor(props.navBackScrolledColor?props.navBackScrolledColor:"black");
                    } else {
                        //Restore initial background color
                        if (globals.parameters.sticky3_debug)
                            console.log("set Transparent")

                        //setNavBackColor(props.navBackColor?props.navBackColor:"transparent");
                        setNavBackColor(props.navBackColor?props.navBackColor:"black");//Force back color to black
                    }
                }
            });
        }
    )

    const rendering = () => {
        return(
            <>
                <nav 
                    ref={navbar_top_ref} 
                    id="navbar_top" 
                    className="navbar navbar-expand-lg navbar-dark"
                    style={{backgroundColor:`${navBackColor}`}}
                    >
                    <div className="container">
                        <a className="navbar-brand" href="/">Jésus est la réponse</a>
                        <button onClick={()=>{setCollapsed(!Collapsed);}} className={`navbar-toggler ${Collapsed?"collapsed":""}`} type="button" data-toggle="collapse" data-bs-target="#main_nav" aria-expanded={`${Toggle?"true":"false"}`} aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className={`collapse navbar-collapse ${Collapsed?"collapse":"collapse show"}`} id="main_nav">
                            <ul className="navbar-nav ms-auto">
                                <li className="nav-item"><a className="nav-link" href="/">Accueil</a></li>
                                {false &&
                                <li className="nav-item"><a className="nav-link" href="/dailyworship">{globals.menu.daily_worship}</a></li>}

                                <li className="nav-item"><a className="nav-link" href={isAuthenticated?"/priere":"login"}>Soumettre une requête</a></li>
                                {false &&
                                <li className="nav-item"><a className="nav-link" href="/bibleread">{globals.menu.bible_read}</a></li>}
                                {globals.parameters.local &&
                                <li className="nav-item"><a className="nav-link" href="/booklets">{globals.menu.booklets}</a></li>}
                                {false && <li><a className={`nav-link  pointer`} data-toggle="dropdown" onClick={() => {dispatch(openModalAbout())}}>Version {globals.menu.version.release}</a></li>}
                                
                                {/** Edification Submenus */}
                                <li className="nav-item dropdown" >
                                    <a className={`nav-link dropdown-toggle pointer ${Toggle2 ? "show" : ""}`} data-toggle="dropdown" onClick={() => {setToggle2(!Toggle2); }}>Edification</a>
                                    <ul className={`dropdown-menu dropdown-menu-right ${Toggle2 ? "show" : ""}`}>
                                        <li className="nav-item"><a className="dropdown-item" href="/dailyworship">{globals.menu.daily_worship}</a></li>                                 
                                        <li className="nav-item"><a className="dropdown-item" href="/bibleread">{globals.menu.bible_read}</a></li>                                 
                                    </ul>
                                </li>
                                {/** Misson Submenus */}
                                <li className="nav-item dropdown" >
                                    <a className={`nav-link dropdown-toggle pointer ${Toggle ? "show" : ""}`} data-toggle="dropdown" onClick={() => {setToggle(!Toggle); }}>La mission</a>
                                    <ul className={`dropdown-menu dropdown-menu-right ${Toggle ? "show" : ""}`}>
                                        <li className="nav-item"><a className="dropdown-item" href="/socialshare">{globals.menu.donate}</a></li>
                                        
                                        {globals.parameters.festival_enabled &&
                                        <li className="nav-item"><a className="dropdown-item" href="/participation">{globals.menu.participation}</a></li>}

                                        <li className="nav-item"><a className="dropdown-item" href="/subscription">{globals.menu.subscribe}</a></li>
                                        <li className="nav-item"><a className="dropdown-item" href="/contact">Nous contacter...</a></li>
                                        <li className="nav-item"><a className="dropdown-item" href="/about">{globals.menu.about_us}</a></li>       
                                        <li className="nav-item"><a className="dropdown-item pointer" onClick={() => {dispatch(openModalAbout())}}>Version {globals.menu.version.release} ...</a></li>                                 
                                    </ul>
                                </li>

                                {/**  Admin submenu */} 
                                {isAuthenticated &&
                                 <Link to="/userlounge" className="btn-round btn btn-danger menu-button-margin">{globals.menu.lounge}</Link>}
                                {!isAuthenticated && globals.parameters.redux_authent &&
                                <li className="nav-item"><a className="nav-link btn btn-primary menu-button-margin" href="/login">Connexion</a></li>}
                                {isAuthenticated && globals.parameters.redux_authent &&
                                <Button className='btn-success menu-button-margin' onClick={()=>{dispatch(logout());}}>Déconnexion</Button>}
                            </ul>

                        </div> {/*<!-- navbar-collapse.// -->*/}
                    </div> {/*<!-- container-fluid.// -->*/}
                </nav>
            </>
        )
    } 

    return(
        <>
            {rendering()}
        </>
    )
}

export default StickyMenu3;